// Google Analytics 4 配置和工具函數
// 請將 YOUR_GA4_MEASUREMENT_ID 替換為您的實際GA4測量ID

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// GA4 測量ID
export const GA4_MEASUREMENT_ID = 'G-YVZLT151MR';

// 初始化Google Analytics
export const initGA = () => {
  // 創建dataLayer
  window.dataLayer = window.dataLayer || [];
  
  // 定義gtag函數
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  
  // 設置初始配置
  window.gtag('js', new Date());
  window.gtag('config', GA4_MEASUREMENT_ID, {
    page_title: document.title,
    page_location: window.location.href,
  });
};

// 追蹤頁面瀏覽
export const trackPageView = (url: string, title?: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA4_MEASUREMENT_ID, {
      page_path: url,
      page_title: title || document.title,
    });
  }
};

// 追蹤自定義事件
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, {
      event_category: 'User Interaction',
      ...parameters,
    });
  }
};

// 追蹤AI聊天事件
export const trackAIChatEvent = (action: string, parameters?: Record<string, any>) => {
  trackEvent('ai_chat_interaction', {
    event_category: 'AI Chat',
    event_label: action,
    ...parameters,
  });
};

// 追蹤按鈕點擊
export const trackButtonClick = (buttonName: string, location?: string) => {
  trackEvent('button_click', {
    event_category: 'Button Interaction',
    event_label: buttonName,
    button_location: location,
  });
};

// 追蹤轉換事件
export const trackConversion = (conversionType: string, value?: number) => {
  trackEvent('conversion', {
    event_category: 'Conversion',
    event_label: conversionType,
    value: value,
  });
};

// 追蹤用戶旅程
export const trackUserJourney = (step: string, details?: Record<string, any>) => {
  trackEvent('user_journey', {
    event_category: 'User Journey',
    event_label: step,
    ...details,
  });
};

// 追蹤錯誤
export const trackError = (errorType: string, errorMessage: string, errorLocation?: string) => {
  trackEvent('error_occurred', {
    event_category: 'Error',
    event_label: errorType,
    error_message: errorMessage,
    error_location: errorLocation,
  });
};

// 追蹤性能指標
export const trackPerformance = (metricName: string, value: number, unit?: string) => {
  trackEvent('performance_metric', {
    event_category: 'Performance',
    event_label: metricName,
    metric_value: value,
    metric_unit: unit,
  });
};
